// extracted by mini-css-extract-plugin
export default {"limitInfoDiv":"style_limitInfoDiv__td5eB","title":"style_title__OXSJ2","closeBtn":"style_closeBtn__PJTs6","message":"style_message__-aXGP"};